import { categoryMap } from '../../../globals/tracking/integrations'

export const getIntegrationsByCategory = (integrations, category) => {
  const list = []

  integrations.forEach((integration) => {
    if (categoryMap[category].includes(integration)) {
      list.push(integration)
    }
  })

  return list
}
